export default "__VITE_ASSET__D15mElH5__"